import './Hero.css';
import heroBefore from '../assets/hero-before.png';
import heroAfter from '../assets/hero-after.png';

function Hero() {
    return (
        <section className="hero">
            <div className="hero-content">
                <h1>
                    Focus on <span className="nowrap"><span className="highlight">customer care</span>,</span><br />
                    not spreadsheets
                </h1>

                <div className="hero-images">
                    <div className="hero-image-item">
                        <img src={heroBefore} alt="Before - Manual clinic operations" />
                    </div>
                    <div className="hero-image-item">
                        <img src={heroAfter} alt="After - Lemadoo organized operations" />
                    </div>
                </div>

                <p>
                    Clinic management made simple. Lemadoo helps you run daily operations with clarity, structure, and confidence so you can focus on what matters most.
                </p>

                <a href="https://app.lemadoo.com/sign-up" className="cta-button" target="_blank" rel="noopener noreferrer">Get Started for Free</a>
            </div>
        </section>
    );
}

export default Hero;
